import $ from "jquery";

const questionTabs = () => {
  const init = () => {
    //chapterAnimation();
    TabFirst();
  };

  const TabFirst = () => {
    // Questions Tabs Buttons
    const questionNextBtn = $(".js-questionNext");
    const questionPrevBtn = $(".js-questionPrev");
    const questionSubmitBtn = $(".js-btnQuestionLast");
    const questionChoices = $(
      ".mi-QuestionForm__Choices_ChoiceLabel input[type=radio]"
    );

    // let currentIndex = 0;
    // disable next button after load element
    $(() => {
      questionNextBtn.attr("disabled", true);
      $("#questionFirst").addClass("active");
    });

    // Enable or disable navigation buttons based on current index and checked radios
    const updateNavigationButtons = () => {
      let details = $(".active");
      // // eslint-disable-next-line no-console
      // console.log(details);
      let radios = details.find(
        ".mi-QuestionForm__Choices_ChoiceLabel input[type=radio]"
      );
      let button = details.find(".js-questionNext");

      // Check if any radio is checked within the current <details> section
      let isChecked = radios.is(":checked");

      // Enable or disable the button based on radio state
      if (details.attr("id") === "questionLast") {
        questionSubmitBtn.prop("disabled", !isChecked);
      } else {
        button.prop("disabled", !isChecked);
      }
    };

    const action = (el) => {
      const target = el.data("target");
      $(".js-DetailsQuestion").attr("open", false);
      $(`#${target}`).attr("open", true);

      $(`#${target}`).addClass("active");

      if (target === "thankyou" || target === "thankyou-end") {
        $(".js-mi-Character--Question").show();

      }

      if (target === "questionLast") {
        questionSubmitBtn.attr("disabled", true);
      }
    };

    questionNextBtn.add(questionPrevBtn).on("click", function () {
      $(".js-DetailsQuestion").removeClass("active");

      action($(this));
      updateNavigationButtons();
    });

    // handle disable button when choices change
    questionChoices.on("change", function (e) {
      e.preventDefault();
      updateNavigationButtons();
    });

    // questionSubmitBtn.on("click", function () {
    //   window.location.href = '/question-end';
    //   return false;
    // })
  };

  init();
};

questionTabs();
